import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { getAppById } from '../apps';
import './AppPage.css';

/**
 * 各应用的占位页。除 eg 外，所有应用都是顶层路由，彼此平级。
 * 等具体功能确定后，用真实页面替换这里即可，桌面层与路由都不用改。
 */
function AppPage() {
  const { appId } = useParams();
  const navigate = useNavigate();
  const app = getAppById(appId);

  if (!app) {
    return (
      <main className="app-page">
        <header className="app-page__bar">
          <button type="button" className="app-page__back" onClick={() => navigate('/')}>
            <ArrowLeft size={18} aria-hidden="true" />
            返回
          </button>
        </header>
        <div className="app-page__empty">
          <h1 className="app-page__title">页面不存在</h1>
          <p className="app-page__desc">这个地址没有对应的应用。</p>
        </div>
      </main>
    );
  }

  const Icon = app.icon;

  return (
    <main className="app-page" style={{ '--tint': app.tint }}>
      <header className="app-page__bar">
        <button
          type="button"
          className="app-page__back"
          onClick={() => navigate('/desktop')}
          aria-label="返回桌面"
        >
          <ArrowLeft size={18} aria-hidden="true" />
          桌面
        </button>
        <span className="app-page__name">{app.name}</span>
      </header>

      <div className="app-page__empty">
        <span className="app-page__icon">
          <Icon size={30} strokeWidth={1.6} aria-hidden="true" />
        </span>
        <h1 className="app-page__title">{app.name}</h1>
        <p className="app-page__desc">{app.description}</p>
        <span className="app-page__badge">功能待接入</span>
      </div>
    </main>
  );
}

export default AppPage;
